    import axios from "axios"
    import { authHeader, baseUrl } from "../../utils"
    import { CREATE_DESIGNATION, CREATING_DESIGNATION, DESIGNATIONS_ERROR, GETTING_DESIGNATIONS, GET_DESIGNATIONS, UPDATE_DESIGNATION, UPDATING_DESIGNATION } from "../types"

    export const createDesignation = (designationPayload) => async (dispatch) => {    
        try{
            const headers = authHeader()

            dispatch({
                type: CREATING_DESIGNATION,
                payload: true
            })
            const response = await axios.post(`${baseUrl}/designations`, designationPayload, { headers })
            
            dispatch({
                type: CREATE_DESIGNATION,
                payload: response.data.data
            })
            
        }
        catch(error){
            // console.log(error)
            dispatch({
                type: DESIGNATIONS_ERROR,
                // payload: error.response.data
                error
            })
        }
    }

    export const updateDesignation = (designationId, designationPayload) => async (dispatch) => {    
        try{
            const headers = authHeader()

            dispatch({
                type: UPDATING_DESIGNATION,
                payload: true
            })

            const response = await axios.patch(`${baseUrl}/designations/${designationId}`, designationPayload, { headers })
            
            dispatch({
                type: UPDATE_DESIGNATION,
                payload: response.data.data
            })
            
        }
        catch(error){
            // console.log(error)
            dispatch({
                type: DESIGNATIONS_ERROR,
                // payload: error.response.data
                error
            })
        }
    }

    export const fetchDesignations = (filterString, page, perPage) => async dispatch => {    
        try{
            const headers = authHeader()
            let url = 'designations?expand=department'

            dispatch( {
                type: GETTING_DESIGNATIONS,
                payload: true
            })

            if(filterString && filterString !== '') {
                url += `${url.includes('?') ? '&' : '?'}${filterString}`
            }

            if((page || page === 0) && page!=='') {
                url += `${url.includes('?') ? '&' : '?'}page=${page}`
            }

            if((perPage || perPage === 0) && perPage!=='') {
                url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
            }


            const response = await axios.get(`${baseUrl}/${url}`, { headers })
            // const response = await axios.get(`${process.env.REACT_APP_API_URL}/${requestUrl}?expand=custodian&limit=${pagination.perPage}&page=${pagination.page}&${appliedFilters}&${applySort(sort)}`, { headers })

            dispatch( {
                type: GET_DESIGNATIONS,
                payload: response.data.data
            })
            
        }
        catch(error){
            dispatch( {
                type: DESIGNATIONS_ERROR,
                // payload: error.response.data,
                error
            })
        }
    }

    export const clearCreatedDesignation = () => async dispatch => {    
        dispatch({
            type: CREATE_DESIGNATION,
            payload: null
        })
    }

    export const clearUpdatedDesignation = () => async dispatch => {    
        dispatch({
            type: UPDATE_DESIGNATION,
            payload: null
        })
    }